/*
  BMX History Relational Archive. Shared JS utilities.
  Legend Bike Co.

  Small helper module. Attached to window.BMXArchive so sections can use it
  without a bundler. No dependencies. Safe to load in the theme's global scope.
*/
(function () {
  'use strict';

  var BMXArchive = window.BMXArchive || {};

  /* Entity color palette. Mirror of the CSS variables so JS-drawn graphs
     (Cytoscape) and popups can pick the same colors. */
  BMXArchive.colors = {
    rider:    '#c0392b',
    track:    '#2e7d32',
    brand:    '#1a3a8c',
    hardware: '#b8860b',
    unknown:  '#6b6b6b'
  };

  /* Friendly labels for legends and tooltips. */
  BMXArchive.labels = {
    rider:    'Rider',
    track:    'Track',
    brand:    'Brand',
    hardware: 'Hardware'
  };

  /* Build a link to a chapter page. If page_handle is set, use /pages/handle.
     Otherwise fall back to the raw metaobject URL passed in. */
  BMXArchive.linkFor = function (pageHandle, fallbackUrl) {
    if (pageHandle && String(pageHandle).length > 0) {
      return '/pages/' + String(pageHandle).replace(/^\/+/, '');
    }
    return fallbackUrl || '#';
  };

  /* Open a URL in a new tab, safe rel. */
  BMXArchive.openInNewTab = function (url) {
    if (!url) { return; }
    var w = window.open(url, '_blank');
    if (w) { w.opener = null; }
  };

  /* Parse "YYYY-YYYY" or "YYYY-present" into [start, end].
     Returns null if we cannot parse it. */
  BMXArchive.parseYearRange = function (raw, presentYear) {
    if (!raw) { return null; }
    var s = String(raw).trim().toLowerCase();
    var m = s.match(/^(\d{4})\s*[-–]\s*(\d{4}|present|current|now)$/);
    if (!m) {
      var single = s.match(/^(\d{4})$/);
      if (single) {
        var y = parseInt(single[1], 10);
        return [y, y];
      }
      return null;
    }
    var start = parseInt(m[1], 10);
    var end = m[2];
    if (end === 'present' || end === 'current' || end === 'now') {
      end = presentYear || new Date().getFullYear();
    } else {
      end = parseInt(end, 10);
    }
    if (isNaN(start) || isNaN(end)) { return null; }
    if (end < start) { var t = start; start = end; end = t; }
    return [start, end];
  };

  /* Parse "lat,lng" into [lat, lng] floats. Returns null on failure. */
  BMXArchive.parseCoords = function (raw) {
    if (!raw) { return null; }
    var parts = String(raw).split(',');
    if (parts.length < 2) { return null; }
    var lat = parseFloat(parts[0]);
    var lng = parseFloat(parts[1]);
    if (isNaN(lat) || isNaN(lng)) { return null; }
    return [lat, lng];
  };

  /* Read a JSON blob out of a <script type="application/json" id="..."> tag.
     Returns null if the tag or JSON is missing / bad. */
  BMXArchive.readJSON = function (elementId) {
    var el = document.getElementById(elementId);
    if (!el) { return null; }
    try {
      return JSON.parse(el.textContent || el.innerText || 'null');
    } catch (e) {
      return null;
    }
  };

  /* True if two [start, end] ranges overlap. */
  BMXArchive.rangesOverlap = function (a, b) {
    if (!a || !b) { return false; }
    return a[0] <= b[1] && b[0] <= a[1];
  };

  window.BMXArchive = BMXArchive;
})();
